export default function BestSellers() {
  return <h1>BestSellers</h1>;
}
